import Dialog from "components/Dialog";
import RenderHtmlComponent from "components/RenderHtml";
import React from "react";
import { ScrollView } from "react-native";
import FanRallyTOS from "./FanRallyTOS";

interface FanRallyTOSDialogProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const FanRallyTOSDialog: React.FC<FanRallyTOSDialogProps> = ({
  visible,
  setVisible,
}) => {
  return (
    <Dialog
      visible={visible}
      setVisible={setVisible}
      style={{ padding: 15 }}
      onOk={() => setVisible(false)}
      okText="OK"
    >
      <ScrollView style={{ maxHeight: 500 }}>
        <RenderHtmlComponent source={FanRallyTOS} />
      </ScrollView>
    </Dialog>
  );
};

export default FanRallyTOSDialog;
